import React, { useMemo } from 'react'

import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

import {
  CollapsibleContainer,
  CollapsibleDivComponentContainer,
  CollapsibleButtonComponentContainer,
  ChildrenWrapper
} from './styled'

const Collapsible = props => {
  const {
    notCollapsible,
    isExtended,
    hideBottomLine,
    children,
    onClick,
    headerStyledComponent
  } = props

  const childrenWrapperId = useMemo(() => uuid(), [])

  return (
    <CollapsibleContainer hideBottomLine={hideBottomLine || isExtended}>
      {notCollapsible ? (
        <CollapsibleDivComponentContainer onClick={!notCollapsible ? onClick : undefined}>
          {// Use of cloneElement to pass the config props the the StyledHeader
          React.cloneElement(headerStyledComponent, props)}
        </CollapsibleDivComponentContainer>
      ) : (
        <CollapsibleButtonComponentContainer
          onClick={!notCollapsible ? onClick : undefined}
          aria-expanded={isExtended}
          aria-controls={childrenWrapperId}
        >
          {// Use of cloneElement to pass the config props the the StyledHeader
          React.cloneElement(headerStyledComponent, props)}
        </CollapsibleButtonComponentContainer>
      )}
      {children && (
        <ChildrenWrapper isVisible={isExtended} childrenWrapperId={childrenWrapperId}>
          {children}
        </ChildrenWrapper>
      )}
    </CollapsibleContainer>
  )
}

Collapsible.propTypes = {
  isExtended: PropTypes.bool,
  notCollapsible: PropTypes.bool
}

export default Collapsible
